const locale = {
	pageTitle: 'Responsible Minerals Sourcing Policy | QingYi Precision',
	pageDesc:
		'QingYi Precision Responsible Minerals Sourcing Policy. Aligned with RBA standards and the OECD Due Diligence Guidance, ensuring tin, tantalum, tungsten and gold (3TG) sources are conflict-free and traceable, with suppliers required to submit CMRT/EMRT and sign a conflict-free metals declaration.',
	pageKeywords:
		'Responsible Minerals Sourcing Policy, conflict minerals, 3TG, RBA, OECD due diligence, CMRT, EMRT, conflict-free metals declaration, QingYi Precision',
	title: 'Responsible Minerals Sourcing Policy',
	subtitle: '負責任礦產採購政策',
	clickHint: 'Click the image to enlarge',
	intro:
		'To implement responsible minerals sourcing and to support human rights and sustainable development, QingYi Precision Co., Ltd. is committed to following the standards of the Responsible Business Alliance (RBA) and to continuously monitoring and improving issues related to the sources of conflict minerals. QingYi Precision avoids directly or indirectly financing illegal armed groups located in conflict-affected and high-risk areas, and ensures that the sources of tin, tantalum, tungsten and gold (3TG), as well as cobalt, mica, graphite, lithium, nickel and other metals comply with this policy and are traceable.',
	commitLead: 'To this end, QingYi Precision makes the following commitments:',
	sections: [
		{
			heading:
				'1. In accordance with the OECD Due Diligence Guidance for Responsible Supply Chains of Minerals from Conflict-Affected and High-Risk Areas, we adopt an auditable and verifiable due diligence framework, and:',
			items: [
				'Require suppliers to complete the Responsible Minerals Initiative (RMI) CMRT (Conflict Minerals Reporting Template) and EMRT (Extended Minerals Reporting Template) disclosure forms.',
				'Review, consolidate and retain the data accordingly, and continuously conduct supply chain risk monitoring and management.'
			]
		},
		{
			heading:
				'2. Clearly communicate with and require suppliers to ensure that the sources of metals in their products are traceable and compliant with this policy, so as to keep the entire supply chain free of conflict minerals.',
			items: []
		},
		{
			heading: '3. Implement conflict minerals management across the supply chain through the following measures:',
			items: [
				'Establish a conflict minerals policy.',
				'Do not purchase conflict minerals originating from conflict areas.',
				'Require suppliers to sign a Conflict-Free Metals Declaration.'
			]
		}
	],
	footnote:
		'Raw materials supplied by our suppliers must not directly or indirectly use conflict minerals and must comply with conflict-free minerals requirements. If conflict minerals are found to be used in a supplier’s products, necessary measures will be taken to discontinue the use of such conflict minerals.',
	company: 'QingYi Precision Co., Ltd.',
	companyEn: '擎億精密有限公司'
};

export default locale;
